import React, { useState } from 'react';
import { Layout, Menu, Button, Dropdown, Modal, Form, Input, message, Avatar, Typography, Space } from 'antd';
import {
  DashboardOutlined,
  ShoppingOutlined,
  ThunderboltOutlined,
  TeamOutlined,
  UserOutlined,
  LogoutOutlined,
  EditOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  MergeCellsOutlined,
} from '@ant-design/icons';
import { useLocation, useNavigate } from 'react-router-dom';
import axios from './auth';

const { Header, Sider, Content } = Layout;
const { Text } = Typography;

function AdminLayout({ children }) {
  const navigate = useNavigate();
  const location = useLocation();
  const username = localStorage.getItem('username') || '用户';
  const userId = parseInt(localStorage.getItem('user_id') || '0');
  const isAdmin = userId === 1;
  const [collapsed, setCollapsed] = useState(false);
  const [nickname, setNickname] = useState(localStorage.getItem('nickname') || username);
  const [nicknameModalVisible, setNicknameModalVisible] = useState(false);
  const [nicknameForm] = Form.useForm();

  const selectedKey = location.pathname === '/' ? '/' : location.pathname;

  const menuItems = [
    { key: '/', icon: <DashboardOutlined />, label: '工作台' },
    { key: '/product', icon: <ShoppingOutlined />, label: '商品管理' },
    { key: '/gen2', icon: <ThunderboltOutlined />, label: '动作视频' },
    { key: '/merge', icon: <MergeCellsOutlined />, label: '视频合并' },
    ...(isAdmin ? [{ key: '/users', icon: <TeamOutlined />, label: '用户管理' }] : []),
  ];

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('username');
    localStorage.removeItem('user_id');
    localStorage.removeItem('nickname');
    navigate('/login');
    window.location.reload();
  };

  const openNicknameModal = () => {
    nicknameForm.setFieldsValue({ nickname });
    setNicknameModalVisible(true);
  };

  const handleNicknameOk = () => {
    nicknameForm.validateFields().then(values => {
      axios.put('/api/auth/nickname', { nickname: values.nickname })
        .then(res => {
          if (res.data.success) {
            const newNickname = res.data.nickname;
            setNickname(newNickname);
            localStorage.setItem('nickname', newNickname);
            message.success('昵称修改成功');
            setNicknameModalVisible(false);
          } else {
            message.error(res.data.error || '修改失败');
          }
        })
        .catch(err => {
          message.error(err.response?.data?.error || '修改失败');
        });
    });
  };

  const userMenuItems = [
    {
      key: 'nickname',
      icon: <EditOutlined />,
      label: '修改昵称',
      onClick: openNicknameModal,
    },
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: '退出登录',
      onClick: handleLogout,
    },
  ];

  return (
    <Layout className="admin-shell">
      <Sider
        width={240}
        collapsedWidth={72}
        collapsed={collapsed}
        className="admin-sider"
        breakpoint="lg"
        onBreakpoint={setCollapsed}
      >
        <div className="admin-brand">
          <div className="admin-brand-mark">AI</div>
          {!collapsed && (
            <div className="admin-brand-text">
              <strong>GenVideo</strong>
              <span>智能试穿后台</span>
            </div>
          )}
        </div>
        <Menu
          mode="inline"
          selectedKeys={[selectedKey]}
          items={menuItems}
          onClick={({ key }) => navigate(key)}
          className="admin-menu"
        />
      </Sider>

      <Layout className="admin-main">
        <Header className="admin-header">
          <Button
            type="text"
            className="admin-collapse"
            icon={collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
            onClick={() => setCollapsed(!collapsed)}
          />
          <div className="admin-header-title">
            <Text strong>AI试穿短视频生成器</Text>
            <span>商品素材、形象资产与视频生成工作台</span>
          </div>
          <Dropdown menu={{ items: userMenuItems }} placement="bottomRight">
            <Button className="admin-user-button">
              <Space size={8}>
                <Avatar size={28} style={{ backgroundColor: '#18ad25' }} icon={<UserOutlined />} />
                <span>{nickname}</span>
              </Space>
            </Button>
          </Dropdown>
        </Header>

        <Content className="admin-content">
          {children}
        </Content>
      </Layout>

      <Modal
        title="修改昵称"
        open={nicknameModalVisible}
        onOk={handleNicknameOk}
        onCancel={() => setNicknameModalVisible(false)}
        okText="确定"
        cancelText="取消"
      >
        <Form form={nicknameForm} layout="vertical" style={{ marginTop: 16 }}>
          <Form.Item
            name="nickname"
            label="昵称"
            rules={[
              { required: true, message: '请输入昵称' },
              { max: 50, message: '昵称最多50个字符' },
            ]}
          >
            <Input placeholder="请输入新昵称" />
          </Form.Item>
        </Form>
      </Modal>
    </Layout>
  );
}

export default AdminLayout;